<script lang="ts" setup>
import { useColors } from 'vuestic-ui';
import { useThemeStore } from './stores/themeStore';
import AuthWrapper from '@/components/AuthWrapper.vue';
import { useRoute } from 'vue-router'

const themeStore = useThemeStore();
const route = useRoute();
const { applyPreset } = useColors();
applyPreset(themeStore.theme);
</script>

<template>
  <Suspense>
    <template #fallback>
      <div class="flex items-center justify-center h-full w-full">
        Loading...
      </div>
    </template>
    <AuthWrapper :key="route.fullPath">
      <RouterView />
    </AuthWrapper>
  </Suspense>
</template>

<style lang="scss">
#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  min-width: 20rem;
}
</style>
